/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum InsuranceCompany {
    Sonstige = 'Sonstige',
    Allianz = 'Allianz',
    Arag = 'Arag',
    Dialog = 'Dialog',
    Donau = 'Donau',
    Ergo = 'Ergo',
    Generali = 'Generali',
    Hdi = 'Hdi',
    Merkur = 'Merkur',
    Muki = 'Muki',
    NoeVs = 'NoeVs',
    OoeVs = 'OoeVs',
    Uniqa = 'Uniqa',
    Vav = 'Vav',
    Vig = 'Vig',
    Wuestenrot = 'Wuestenrot',
    Zurich = 'Zurich',
    Servo = 'Servo',
    Callidus = 'Callidus',
    Grawe = 'Grawe',
    Helvetia = 'Helvetia',
    EuropaeischeReiseversicherung = 'EuropaeischeReiseversicherung',
    Gothaer = 'Gothaer',
    Nuernberger = 'Nuernberger',
    Rv = 'Rv',
    VereintVag = 'VereintVag',
    Forbroker = 'Forbroker',
    HelveticWarranty = 'HelveticWarranty',
    Markel = 'Markel',
    Tiroler = 'Tiroler'
  }

    export const InsuranceCompanyTranslocoMap: Record<InsuranceCompany, string> = {
    [InsuranceCompany.Sonstige]: 'insuranceCompany.sonstige',
    [InsuranceCompany.Allianz]: 'insuranceCompany.allianz',
    [InsuranceCompany.Arag]: 'insuranceCompany.arag',
    [InsuranceCompany.Dialog]: 'insuranceCompany.dialog',
    [InsuranceCompany.Donau]: 'insuranceCompany.donau',
    [InsuranceCompany.Ergo]: 'insuranceCompany.ergo',
    [InsuranceCompany.Generali]: 'insuranceCompany.generali',
    [InsuranceCompany.Hdi]: 'insuranceCompany.hdi',
    [InsuranceCompany.Merkur]: 'insuranceCompany.merkur',
    [InsuranceCompany.Muki]: 'insuranceCompany.muki',
    [InsuranceCompany.NoeVs]: 'insuranceCompany.noeVs',
    [InsuranceCompany.OoeVs]: 'insuranceCompany.ooeVs',
    [InsuranceCompany.Uniqa]: 'insuranceCompany.uniqa',
    [InsuranceCompany.Vav]: 'insuranceCompany.vav',
    [InsuranceCompany.Vig]: 'insuranceCompany.vig',
    [InsuranceCompany.Wuestenrot]: 'insuranceCompany.wuestenrot',
    [InsuranceCompany.Zurich]: 'insuranceCompany.zurich',
    [InsuranceCompany.Servo]: 'insuranceCompany.servo',
    [InsuranceCompany.Callidus]: 'insuranceCompany.callidus',
    [InsuranceCompany.Grawe]: 'insuranceCompany.grawe',
    [InsuranceCompany.Helvetia]: 'insuranceCompany.helvetia',
    [InsuranceCompany.EuropaeischeReiseversicherung]: 'insuranceCompany.europaeischeReiseversicherung',
    [InsuranceCompany.Gothaer]: 'insuranceCompany.gothaer',
    [InsuranceCompany.Nuernberger]: 'insuranceCompany.nuernberger',
    [InsuranceCompany.Rv]: 'insuranceCompany.rv',
    [InsuranceCompany.VereintVag]: 'insuranceCompany.vereintVag',
    [InsuranceCompany.Forbroker]: 'insuranceCompany.forbroker',
    [InsuranceCompany.HelveticWarranty]: 'insuranceCompany.helveticWarranty',
    [InsuranceCompany.Markel]: 'insuranceCompany.markel',
    [InsuranceCompany.Tiroler]: 'insuranceCompany.tiroler',
    };

    export const InsuranceCompanyOptions = [
  { value: InsuranceCompany.Sonstige, labelKey: 'insuranceCompany.sonstige' },
  { value: InsuranceCompany.Allianz, labelKey: 'insuranceCompany.allianz' },
  { value: InsuranceCompany.Arag, labelKey: 'insuranceCompany.arag' },
  { value: InsuranceCompany.Dialog, labelKey: 'insuranceCompany.dialog' },
  { value: InsuranceCompany.Donau, labelKey: 'insuranceCompany.donau' },
  { value: InsuranceCompany.Ergo, labelKey: 'insuranceCompany.ergo' },
  { value: InsuranceCompany.Generali, labelKey: 'insuranceCompany.generali' },
  { value: InsuranceCompany.Hdi, labelKey: 'insuranceCompany.hdi' },
  { value: InsuranceCompany.Merkur, labelKey: 'insuranceCompany.merkur' },
  { value: InsuranceCompany.Muki, labelKey: 'insuranceCompany.muki' },
  { value: InsuranceCompany.NoeVs, labelKey: 'insuranceCompany.noeVs' },
  { value: InsuranceCompany.OoeVs, labelKey: 'insuranceCompany.ooeVs' },
  { value: InsuranceCompany.Uniqa, labelKey: 'insuranceCompany.uniqa' },
  { value: InsuranceCompany.Vav, labelKey: 'insuranceCompany.vav' },
  { value: InsuranceCompany.Vig, labelKey: 'insuranceCompany.vig' },
  { value: InsuranceCompany.Wuestenrot, labelKey: 'insuranceCompany.wuestenrot' },
  { value: InsuranceCompany.Zurich, labelKey: 'insuranceCompany.zurich' },
  { value: InsuranceCompany.Servo, labelKey: 'insuranceCompany.servo' },
  { value: InsuranceCompany.Callidus, labelKey: 'insuranceCompany.callidus' },
  { value: InsuranceCompany.Grawe, labelKey: 'insuranceCompany.grawe' },
  { value: InsuranceCompany.Helvetia, labelKey: 'insuranceCompany.helvetia' },
  { value: InsuranceCompany.EuropaeischeReiseversicherung, labelKey: 'insuranceCompany.europaeischeReiseversicherung' },
  { value: InsuranceCompany.Gothaer, labelKey: 'insuranceCompany.gothaer' },
  { value: InsuranceCompany.Nuernberger, labelKey: 'insuranceCompany.nuernberger' },
  { value: InsuranceCompany.Rv, labelKey: 'insuranceCompany.rv' },
  { value: InsuranceCompany.VereintVag, labelKey: 'insuranceCompany.vereintVag' },
  { value: InsuranceCompany.Forbroker, labelKey: 'insuranceCompany.forbroker' },
  { value: InsuranceCompany.HelveticWarranty, labelKey: 'insuranceCompany.helveticWarranty' },
  { value: InsuranceCompany.Markel, labelKey: 'insuranceCompany.markel' },
  { value: InsuranceCompany.Tiroler, labelKey: 'insuranceCompany.tiroler' },
    ];

